import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import VodafoneBadge from '../components/VodafoneBadge';

const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));

function Card({ title, children, style }) {
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 14, padding: 18, ...style }}>
      <h2 style={{ margin: '0 0 12px', fontSize: 15 }}>{title}</h2>
      {children}
    </div>
  );
}
function Bar({ label, value, total, color }) {
  const pct = total ? Math.round((value / total) * 100) : 0;
  return (
    <div style={{ marginBottom: 9 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 3 }}>
        <span style={{ fontWeight: 600 }}>{label}</span><span style={{ color: 'var(--muted)' }}>{nf(value)} · {pct}%</span>
      </div>
      <div style={{ height: 9, background: 'var(--surface-2)', borderRadius: 6, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: color, transition: 'width .4s' }} />
      </div>
    </div>
  );
}

export default function AgenteVfPage() {
  const [d, setD] = useState(null);
  const load = useCallback(() => { axios.get(`${API}/gea/dashboard`).then((r) => setD(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); const t = setInterval(load, 12000); return () => clearInterval(t); }, [load]);

  const totEsiti = d ? (d.vodafone || 0) + (d.negativi || 0) + (d.errori || 0) : 0;
  const job = d?.job;

  return (
    <div style={{ padding: 20, maxWidth: 900, margin: '0 auto' }}>
      <h1 style={{ fontSize: 20, margin: '0 0 4px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <VodafoneBadge size={22} /> AI VF — linea Vodafone
      </h1>
      <p style={{ margin: '0 0 18px', color: 'var(--muted)', fontSize: 13 }}>
        Verifica se i numeri <b>NON TIM</b> (fissi) sono Vodafone. Chi ha il permesso vede il logo accanto al risultato 456.
      </p>

      {!d ? <div style={{ color: 'var(--faint)' }}>Caricamento…</div> : (
        <>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
            <Card title="Stato agente" style={{ flex: 1, minWidth: 280 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14 }}>
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: d.agente_attivo ? 'var(--ok)' : 'var(--line)' }} />
                <b>{d.abilitata === false ? 'Disabilitato' : d.agente_attivo ? (job ? 'In verifica' : 'In attesa') : 'Fermo'}</b>
                {job && <span style={{ color: 'var(--muted)' }}>{nf(job.completed)}/{nf(job.total)} · {nf(job.vodafone)} Vodafone</span>}
              </div>
              <div style={{ marginTop: 12, fontSize: 12, color: 'var(--muted)' }}>
                Da verificare: <b>{nf(d.eligibili)}</b> · NON TIM fissi: {nf(d.non_tim)}
              </div>
            </Card>
            <Card title="Riepilogo" style={{ flex: 1, minWidth: 280 }}>
              <div style={{ display: 'flex', gap: 22, flexWrap: 'wrap' }}>
                <div><div style={{ fontSize: 22, fontWeight: 800, color: 'var(--err)' }}>{nf(d.vodafone)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>Vodafone</div></div>
                <div><div style={{ fontSize: 22, fontWeight: 800, color: 'var(--ok)' }}>{nf(d.nuovi)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>Nuovi</div></div>
                <div><div style={{ fontSize: 22, fontWeight: 800 }}>{nf(d.confermati)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>Confermati</div></div>
                <div><div style={{ fontSize: 22, fontWeight: 800 }}>{nf(d.verificati)}</div><div style={{ fontSize: 11, color: 'var(--muted)' }}>Verificati</div></div>
              </div>
            </Card>
          </div>

          <Card title="Ripartizione esiti">
            {totEsiti === 0 ? (
              <div style={{ color: 'var(--faint)', fontSize: 13 }}>Nessuna verifica ancora.</div>
            ) : (
              <>
                <Bar label="Vodafone" value={d.vodafone} total={totEsiti} color="#e60000" />
                <Bar label="Non Vodafone" value={d.negativi} total={totEsiti} color="#64748b" />
                <Bar label="Errori" value={d.errori} total={totEsiti} color="#f59e0b" />
              </>
            )}
          </Card>
        </>
      )}
    </div>
  );
}
